import { SystemTheme } from "@wind/db/kysely/types";

import { WINDMILL_DARK_THEME, WINDMILL_LIGHT_THEME } from "./themes.js";

const getThemeVariables = (theme: SystemTheme) => {
  switch (theme) {
    case SystemTheme.DARK:
      return WINDMILL_DARK_THEME;
    case SystemTheme.LIGHT:
      return WINDMILL_LIGHT_THEME;
  }
};

export default getThemeVariables;
